import { jsxs as e, jsx as i } from "react/jsx-runtime";
import { PageTitle as N } from "@strata/react-page-title";
import m from "classnames";
import { Resizable as W } from "re-resizable";
import { useResizeDetector as g } from "react-resize-detector";
import "./main.scss";
const a = 70, n = 300, j = ({
  sidebarHeaderContent: s = void 0,
  sidebarContent: r = void 0,
  mainContent: _ = void 0,
  title: o = void 0,
  secondaryTitle: b = void 0,
  headerContent: h = void 0,
  sidebarRenderWidth: p = void 0,
  noSidebarPadding: f = !1,
  onSidebarResize: d = void 0
}) => {
  const l = g(), c = Math.min(
    n,
    Math.max(
      a,
      p ?? (window.innerWidth > 480 ? n : a)
    )
  ), t = (l.width ? l.width + 33 : c) <= a;
  return /* @__PURE__ */ e("div", { className: "sds_collapsible-sidebar-and-main-content", children: [
    /* @__PURE__ */ i(
      W,
      {
        defaultSize: { width: c, height: "100%" },
        minWidth: a,
        maxWidth: n,
        enable: {
          top: !1,
          right: !0,
          bottom: !1,
          left: !1,
          topRight: !1,
          bottomRight: !1,
          bottomLeft: !1,
          topLeft: !1
        },
        onResizeStop: (x, w, v) => d == null ? void 0 : d(v.clientWidth),
        children: /* @__PURE__ */ i(
          "div",
          {
            className: m(
              "sds_collapsible-sidebar-and-main-content__scroll-area",
              "sds_collapsible-sidebar-and-main-content__scroll-area--right-border",
              {
                "sds_collapsible-sidebar-and-main-content__scroll-area--no-padding": f
              }
            ),
            ref: l.ref,
            children: /* @__PURE__ */ e("div", { className: "sds_collapsible-sidebar-and-main-content__sidebar", children: [
              s && /* @__PURE__ */ e(
                "div",
                {
                  className: m(
                    "sds_collapsible-sidebar-and-main-content__sidebar-header",
                    {
                      "sds_collapsible-sidebar-and-main-content__sidebar-header--minimized": t
                    }
                  ),
                  children: [
                    s.minimized,
                    !t && s.expanded
                  ]
                }
              ),
              t ? /* @__PURE__ */ i("div", { className: "sds_collapsible-sidebar-and-main-content__sidebar-content--minimized" }) : r
            ] })
          }
        )
      }
    ),
    /* @__PURE__ */ e("div", { className: "sds_collapsible-sidebar-and-main-content__scroll-area", children: [
      o && /* @__PURE__ */ i(
        N,
        {
          className: "padding__bottom--medium",
          title: o,
          secondaryTitle: b
        }
      ),
      h,
      /* @__PURE__ */ i("div", { className: "sds_collapsible-sidebar-and-main-content__main-content", children: _ })
    ] })
  ] });
};
export {
  j as CollapsibleSidebarAndMainContent
};
//# sourceMappingURL=index.js.map
